import React, { useState } from 'react';
import apiService from '../../services/api';
import { apiErrorMessage, formatEventTime, isPredictionOpen, readPrediction } from '../../utils/gameSchedule';
import ComposeMatch from './ComposeMatch';
import { Modal } from './gameBits';
import { ReactComponent as GamesIcon } from '../../assets/icons/icon-games.svg';

// The standalone compose sheet: a new prediction from the card, or a change from the game
// sheet's Change link, with the how-it-works notes the embed shows under the steppers.
export default function PredictDialog({ event, onClose, onSaved }) {
  const existing = readPrediction(event);
  const [scores, setScores] = useState(existing || { home: 0, away: 0 });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const open = isPredictionOpen(event);
  const time = formatEventTime(event);

  const save = async () => {
    if (saving) return;
    setSaving(true);
    setError('');
    try {
      const response = await apiService.createScheduleEventPrediction(event.id, {
        home_score: scores.home,
        away_score: scores.away,
      });
      const saved = response?.prediction || { home_score: scores.home, away_score: scores.away };
      onSaved({ ...event, already_predicted: true, my_prediction: saved });
      onClose();
    } catch (err) {
      setError(apiErrorMessage(err, 'Could not save prediction'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal label={existing ? 'Change your prediction' : 'Predict the score'} onClose={onClose} className="is-predict">
      <div className="games-sheet-icon">
        <span className="games-predict-badge">
          <GamesIcon />
          Prediction
        </span>
      </div>
      <h2 className="games-sheet-h">{existing ? 'Change your prediction' : 'Predict the score'}</h2>
      <p className="games-sheet-subtitle">{open ? (time === 'TBD' ? 'Locks at start' : `Locks at ${time}`) : 'Predictions lock when the game starts'}</p>
      <ComposeMatch event={event} scores={scores} onChange={setScores} />
      <div className="games-info-card">
        <div>
          <svg className="games-info-icon" viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.6" />
            <path d="M12 10.5v6M12 7.6v.2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
          <span className="games-info-copy">
            <strong>How it works</strong>
            <span>Predict the final score before tipoff. One prediction, locked at tip.</span>
          </span>
        </div>
      </div>
      {error ? <p className="games-dialog-error">{error}</p> : null}
      <div className="games-sheet-buttons">
        <button type="button" className="games-btn is-primary" onClick={save} disabled={saving || !open}>
          {saving ? 'Saving…' : existing ? 'Save prediction' : 'Confirm prediction'}
        </button>
        <button type="button" className="games-btn is-outline" onClick={onClose}>
          Cancel
        </button>
      </div>
    </Modal>
  );
}
